import { UI_TEXT_EM_DASH } from '../../constants/uiText'
import { REFUND_STATUS_TYPES_DIC } from '../constants/refundStatus'

export const FINALIZED_REFUND_STATUSES = [
  REFUND_STATUS_TYPES_DIC.PROCESSED,
  REFUND_STATUS_TYPES_DIC.CANCELLED,
  REFUND_STATUS_TYPES_DIC.RECEIVED
]

export const NCR_REGISTRATION_REFUND_STATUSES = [
  REFUND_STATUS_TYPES_DIC.PROCESSED,
  REFUND_STATUS_TYPES_DIC.SENT,
  REFUND_STATUS_TYPES_DIC.RECEIVED
]

export const NCR_NUMBER_MAX_LENGTH = 24

export const APPROVAL_ACTION_REFUND_STATUSES = [
  REFUND_STATUS_TYPES_DIC.DOCUMENT_PENDING,
  REFUND_STATUS_TYPES_DIC.IN_PROCESS
]

export const REFUND_APPROVAL_DETAIL_TAB = 'detail'
export const REFUND_APPROVAL_HISTORY_TAB = 'history'

export const REFUND_PRODUCTS_TABLE_HEADERS = [
  'CÓDIGO',
  'NOMBRE DEL PRODUCTO',
  'CÓD. BARRA',
  'EMPAQUE',
  'MOTIVO',
  'CONDICIÓN',
  'CANT. ORIG.',
  'CANT. VERIF.',
  'PRECIO',
  'TOTAL',
  'ESTADO'
]

export const getRefundLineCondition = (line = {}) =>
  line.condition || line.product_condition || line.refund_condition || UI_TEXT_EM_DASH

export const getRefundLineListKey = (line = {}, index = 0) => {
  const uid = line.refund_item_uid
  if (uid !== undefined && uid !== null && String(uid).trim() !== '') return String(uid)

  const unit = line.price_unit || line.unit_of_sale || 'UN'
  return `${line.product_db_ref || 'line'}-${unit}-${index}`
}
